import React from "react";
import { Container, Row } from "reactstrap";


function Reclamos(){

    return (
        <>
        <Container className="mt-5" fluid>
              <Row className="mt-5">
                <h2>Hola Reclamos</h2>
              </Row>
        </Container>
        </>
    )
}


export default Reclamos;